import { Check, ShieldCheck } from '@liveauctioneers/hammer-ui-core/icons';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { TrackingEvents } from '@/utils/amplitude/analytics/core.types';
import { useTrackPurchaseProtectionLearnMoreAnalytics } from '@/utils/amplitude/analytics/purchaseProtection/trackPurchaseProtectionLearnMore.analytics';

const PROTECTION_POINTS = [
    'Vetted auction houses',
    'Secure, online bidding',
    'Returns guaranteed for misrepresented listings',
    'Dedicated support when you need it',
];

type Props = {
    className?: string;
    onLearnMoreClick?: () => void;
};

export const ItemPagePurchaseProtection = ({ className, onLearnMoreClick }: Props) => {
    const trackPurchaseProtectionLearnMoreAnalytics = useTrackPurchaseProtectionLearnMoreAnalytics();
    const { formatMessage } = useIntl();

    const handleLearnMoreClick = () => {
        if (onLearnMoreClick) {
            onLearnMoreClick();
        } else {
            trackPurchaseProtectionLearnMoreAnalytics(TrackingEvents.PurchaseProtection.LearnMoreItemPage, {
                description:
                    'User clicks on the "Learn More" link in the "Purchase Protection" section on item detail page',
            });
        }
    };

    return (
        <div
            className={cn(
                'flex flex-col gap-2xs rounded-md border border-border-secondary bg-background-primary p-md smMax:rounded-lg smMax:p-sm',
                className
            )}
        >
            <div className="flex items-center gap-xs">
                <ShieldCheck
                    className="fill-surface-900"
                    size="sm"
                    style="fill"
                />
                <span className="hui-text-h5">{formatMessage({ id: 'itemPagePurchaseProtection.title' })}</span>
            </div>
            <div className="flex flex-col gap-2xs">
                {PROTECTION_POINTS.map((point) => (
                    <div
                        className="flex items-center gap-xs"
                        key={point}
                    >
                        <Check
                            color="success"
                            size="sm"
                            style="bold"
                        />
                        <BodyPrimary>{point}</BodyPrimary>
                    </div>
                ))}
            </div>
            <Link
                aria-label="Learn more about Purchase Protection"
                className="ml-md pl-2xs"
                href="/purchase-protection"
                onClick={handleLearnMoreClick}
            >
                {formatMessage({ id: 'itemPagePurchaseProtection.learnMore' })}
            </Link>
        </div>
    );
};
